import React from 'react';

export const Badge = ({
  children,
  variant = 'default',
  className = '',
  ...props
}) => {
  const getVariantClasses = (variant) => {
    switch (variant) {
      case 'destructive':
        return 'bg-red-100 text-red-800';
      case 'outline':
        return 'border border-gray-300 text-gray-700';
      case 'secondary':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-blue-100 text-blue-800';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getVariantClasses(
        variant
      )} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export { Badge as default };
